import React, { useState, useEffect, forwardRef, Fragment } from "react";
import {FormControl,
        InputLabel,
        Input,
        Grid,
        InputAdornment,
        Chip,
        Select,
        MenuItem,
        TextField,
        FormHelperText
} from "@material-ui/core";
import CategoryIcon from '@material-ui/icons/Category';
import classnames from "classnames";
import useStyles from './styles';
import { useUserState } from "../../context/UserContext";

import './SelectCustomerTestingScopes.css'


const SelectCustomerTestingScopes = forwardRef((props, ref) => {
    const { onTestingScopesSelected, onOtherTestingScopesSpecified } = props
    var { testing_scopes } = useUserState();
    const classes = useStyles();

    const [customer, setCustomer] = useState({...props.customer});
    const [selectedTestingScopes, setSelectedTestingScopes] = useState(undefined);
    const [notes, setNotes] = useState(undefined);
    const [testingScopesSelectionOpen, setTestingScopesSelectionOpen] = useState(false);


    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    };


    useEffect(() => {
      if (customer !== undefined && customer !== null) {
        // for edit customer
        if (customer.id !== undefined && customer.id > 0) {
          if (customer.testing_scopes !== undefined && customer.testing_scopes !== null && customer.testing_scopes.length > 0) {
            setSelectedTestingScopes(customer.testing_scopes);
          }

          if (customer.testing_scope_other_notes !== undefined && customer.testing_scope_other_notes !== null && customer.testing_scope_other_notes !== '') {
            setNotes(customer.testing_scope_other_notes);
          }
        }
        else {
          if (customer.testing_scopes === undefined || customer.testing_scopes === null || customer.testing_scopes.length <= 0) {
             // you can save without selecting testing scopes
          }
          else {
            if (props.isAddCustomer) {
              refreshTestingScopesSelection();
            }
            else {
              setSelectedTestingScopes(customer.testing_scopes);
            }
          }
        }
      }
    }, [customer]);

    useEffect(() => {
      onTestingScopesSelected(selectedTestingScopes);
    },[selectedTestingScopes]);

    function refreshTestingScopesSelection() {
      var newCustomerTestingScopes = selectedTestingScopes;
      newCustomerTestingScopes = newCustomerTestingScopes.filter(testingScope => testing_scopes.filter(item => item.id === testingScope.id).length === 1);
      setSelectedTestingScopes(newCustomerTestingScopes);
      onTestingScopesSelected(newCustomerTestingScopes);
    }

    const handleChange = (event) => {
        setSelectedTestingScopes(event.target.value);
    };

    const handleDelete = (id) => {console.log('handleDelete ', selectedTestingScopes, id)
      const updatedTestingScopes = selectedTestingScopes.filter(item => isNaN(item) ? item.id !== parseInt(id) : item !== parseInt(id));
      setSelectedTestingScopes(updatedTestingScopes);
    };

    const handleOtherTestingScopesSpecified=(event) => {
        setNotes(event.target.value);
        onOtherTestingScopesSpecified(event.target.value);
    }

  const onMouseDown = e => {
    e.stopPropagation();
  };

  return ( testing_scopes && testing_scopes.length > 0 &&
    <div className={classes.contentDiv}>

        <Grid item xs={12}>
          <FormControl variant="outlined"
                       required={props.required ? props.required : false}
                       error={selectedTestingScopes !== undefined && selectedTestingScopes !== null && selectedTestingScopes.length <= 0}
                       className={classnames(classes.testingScopes, {
                        'testing-scopes-control': true
                      })}>
            <InputLabel id="testing-scopes-label">Services</InputLabel>
            <div className={classnames(classes.testingScopesInput, {
                          'testing-scopes-control-input': true
                        })}>
            <InputAdornment position="start">
              <CategoryIcon />
            </InputAdornment>
            <Select
              labelId="testing-scopes-label"
              id="testing-scopes"
              multiple
              className={classnames(classes.testingScopesSelect, {
                           [classes.error]: selectedTestingScopes !== undefined && selectedTestingScopes !== null && selectedTestingScopes.length <= 0
                         })}
              value={selectedTestingScopes ?? []}
              onChange={handleChange}
              open={testingScopesSelectionOpen}
              onClose={() => {setTestingScopesSelectionOpen(false);}}
              onOpen={() => {setTestingScopesSelectionOpen(true);}}
              input={<Input id="testings-scopes-chip" />}
              renderValue={(selected) => (
                <div className={classes.chips}>
                  {selected.map((value) => {
                    return (
                      <Fragment key={value.id || value}>
                          <Chip label={value.name || testing_scopes.filter(item => item.id === value)[0].name}
                                className={classes.chip}
                                onDelete={() => handleDelete(isNaN(value) ? `${value.id}` : `${value}`)}
                                variant="outlined"
                                onMouseDown={onMouseDown}/>
                        </Fragment>
                  );
                })}
                </div>
              )}
              MenuProps={MenuProps}
              size="small"
            >
              {testing_scopes !== undefined && testing_scopes !== null &&
                testing_scopes.length > 0 &&
                testing_scopes.map((testingScope, index) => (
                     <MenuItem key={testingScope.id} value={testingScope}
                        disabled={selectedTestingScopes !== undefined && selectedTestingScopes !== null && selectedTestingScopes.filter(item => item !== undefined && item !== null && (item.id === testingScope.id || item === testingScope.id)).length === 1}
                        onClick={() => {setTestingScopesSelectionOpen(false);}}>
                        <span className="dropdown-avatar">{testingScope.name}</span>
                     </MenuItem>
              ))}


            </Select>
            {selectedTestingScopes === undefined || selectedTestingScopes === null || selectedTestingScopes.length <= 0 && <FormHelperText className={classes.error}>Please select a service.</FormHelperText>}
            </div>
          </FormControl>

          {testing_scopes !== undefined && testing_scopes !== null &&
            testing_scopes.length > 0 && selectedTestingScopes !== undefined && selectedTestingScopes !== null && selectedTestingScopes.length > 0 &&
            selectedTestingScopes.some(ts => ts.name !== undefined && ts.name !== null && ts.name.startsWith('Other')) &&
            <TextField
              id="testing_scopes_notes"
              label="Other services, please specify"
              autoComplete='off'
              onChange={handleOtherTestingScopesSpecified}
              name="name"
              value={notes || ''}
              variant="outlined"
              style={{width: '100%', marginTop: '10px'}}
              required
              error={notes === ''}
              helperText={notes === '' ? 'Please enter the other services.' : ' '}
              size="small"
            />

          }
        </Grid>

    </div>
  );
//}
});
export default SelectCustomerTestingScopes;
